import { gql } from '@lojinha/palantir'

export const FREE_SHIPPING_VALUE = gql`
  query FreeShippingValue {
    freeShippingValue
  }
`
